import { Injectable, inject } from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {EditTeamService} from './edit-team.service';


@Injectable()
export class TeamSizeResolver {
  private team = inject(EditTeamService);
  
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<number> {
    return this.team.loadTeamSize();
  }

}
